import React from "react";
import PolicyPage from "./PolicyPage";
import { policyDocuments } from "../Datas/policyData";

function Delivery() {
  return <PolicyPage document={policyDocuments.shipping} />;
}

export default Delivery;
